import { Link } from "../interfaces/Link";

export const initialLink: Link = {
  text: '',
  link: ''
}
